// Юридический цикл: /api/v2/legal/* (erp-backend, модуль src/legal). [Claude, 03.11.2026]
import { useAxiosCreate } from '@/backend/utils.js'

const api = useAxiosCreate('api')

export async function fetchLegalCases(state = 'open') {
  const { data } = await api.get('legal/cases', { params: { state } })
  return data
}

export async function fetchLegalCase(id) {
  const { data } = await api.get(`legal/cases/${id}`)
  return data
}

export async function registerClaim(payload) {
  const { data } = await api.post('legal/cases', payload)
  return data
}

export async function caseAction(id, action, comment) {
  const { data } = await api.post(`legal/cases/${id}/actions`, { action, comment: comment || null })
  return data
}
